enum CodeBlockNotePresentation {
	// Champs libres, saisis par l'utilisateur
	TITRE = 'Titre',
	SOUS_TITRE = 'Sous-titre',
	PARAGRAPHE = 'Paragraphe',
	// Blocs alimentés à partir des données de la simulation
	TEXTE = 'Texte',
	SECTION_FONCTIONNEMENT = 'Section de fonctionnement',
	GRAPHIQUE = 'Graphique',
	TABLEAU = 'Tableau',
	COMPARATIF = 'Comparatif',
	RATIO = 'Ratio',
}

export default CodeBlockNotePresentation;
